import {
    ChangeDetectionStrategy, Component, Input, OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
    CustomFieldControl, DataService, SharedModule,
} from '@vendure/admin-ui/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ProductVariant } from '@vendure/core';
import gql from 'graphql-tag';
import { notNullOrUndefined } from '../utils';

export const GET_VARIANTS_BY_PRODUCT = gql`
    query product($id: ID) {
        product(id: $id) {
            id
            slug
            name
            variants {
                id
                name
                sku
                enabled
                featuredAsset {
                    id
                    preview
                }
            }
        }
    }
`;

@Component({
    selector: 'relation-product-variant-selector',
    template: `
    <div class="flex items-center">
        <div *ngIf="formControl.value as variant" class="mr-2">
            <a [routerLink]="['/catalog', 'products', parentProductId, 'variants', variant.id]">
                <vdr-chip>{{ variant.name }} ({{ variant.sku }})</vdr-chip>
            </a>
        </div>

        <select
            class="mt-1"
            [formControl]="formControl"
            [disabled]="readonly">
            <option [ngValue]="null">Select a variant…</option>
            <ng-container *ngIf="variants$ | async as variants">
                <option *ngFor="let v of variants" [ngValue]="v">
                    {{ v.name }} ({{ v.sku }})
                </option>
            </ng-container>
        </select>
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule],
})
export class RelationProductVariantSelectorComponent
    implements OnInit, CustomFieldControl {

    @Input() readonly = false;
    @Input() formControl: FormControl;
    @Input() config: any;

    parentProductId: string;
    variants$: Observable<ProductVariant[]>;

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.variants$ = this.route.paramMap.pipe(
            map(p => p.get('id')!),
            switchMap(id => {
                this.parentProductId = id;
                return this.dataService
                    .query(GET_VARIANTS_BY_PRODUCT, { id: id })
                    .mapSingle((data:any) => {
                        return data?.product.variants.filter((enabled: boolean) => enabled).filter(notNullOrUndefined);
                    });
            }),
        );
    }
}